<div class="row filter-bar lookup-section" padding="8px 0 8px 0">
  <!-- <mat-form-field appearance="outline"> -->
  <div class="col center custom-width">
    <div class="row chip-list">
      <mat-form-field floatLabel="always" appearance="outline" class="chip-list margin s9 top left">
        <mat-label>RPA Lookup</mat-label>
        <mat-chip-grid #chipGrid aria-label="Enter RPA Number">
          <mat-chip-row
            [ngClass]="{ 'red-pill': redPill, 'green-pill': greenPill }"
            *ngFor="let rpa of rpas"
            (removed)="removeRPALookup(rpa)"
            [aria-description]="'press enter to edit '"
          >
            <span class="white-font" *ngIf="rpa && rpa.orderNumber && !rpa.expirationDate"
              >{{ rpa.authorizationNumber }} : Order # {{ rpa.orderNumber }}</span
            >
            <span class="white-font" *ngIf="rpa && !rpa.orderNumber && !rpa.expirationDate"
              >{{ rpa.authorizationNumber }} : Not used</span
            >
            <span class="white-font" *ngIf="rpa && rpa.expirationDate"
              >{{ rpa.authorizationNumber }} : Exp. {{ rpa.expirationDate | date : 'MM-dd-yy' }}</span
            >
            <button matChipRemove>
              <mat-icon>close</mat-icon>
            </button>
          </mat-chip-row>

          <input
            placeholder="{{ rpaPlaceholder }}"
            [matChipInputFor]="chipGrid"
            (matChipInputTokenEnd)="addRPALookup($event)"
            [disabled]="rpas.length > 0"
          />
        </mat-chip-grid>
      </mat-form-field>
      <button
        class="margin s9 top"
        matTooltip="To lookup an RPA, enter the RPA number and press enter. To remove an RPA, click the X on the chip. Only one (1) RPA can be searched at a time."
        aria-label="RPA Lookup tip"
        mat-icon-button
      >
        <mat-icon fontSet="material-icons-outlined">info</mat-icon>
      </button>
    </div>
  </div>
  <div class="col"></div>
  <div class="col select-user">
    <div class="row center">
      <div style="width: 100%" class="margin sm right left">
        <mat-form-field floatLabel="always" appearance="outline" class="maxWidth">
          <mat-select
            flex
            [formControl]="userFilterForm"
            multiple
            (selectionChange)="select()"
          >
            <mat-select-header class="padding lrg all">
              <mat-checkbox (change)="toggleSelectAll()" [checked]="allSelected" value="0">Select All</mat-checkbox>
            </mat-select-header>

            <mat-option *ngFor="let user of usersToFilterBy" [value]="user"
              >{{ user.firstName }} {{ user.lastName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- <phx-icon [size]="24" [iconName]="'times'"></phx-icon> -->
    </div>
  </div>

  <!-- </mat-form-field> -->
</div>
<div class="row kanban-wrapper">
  <div class="col kanban-card-col half-width">
    <div class="custom padding all kanban-header">In Progress</div>
    <div class="list-scroll scroll">
      <div
        class="col kanban-col kanban-card-col full-width"
        cdkDropList
        #doingList="cdkDropList"
        [cdkDropListData]="{ items: filteredDoing }"
        (cdkDropListDropped)="drop($event)"
      >
        <app-kanban-card
          [items]="filteredDoing"
          [selectedUsers]="selectedUsers"
          [users]="usersNamesList"
          [user]="user"
        ></app-kanban-card>
      </div>
    </div>
  </div>

  <div class="col kanban-card-col half-width">
    <div class="custom padding all kanban-header">MECS</div>
    <!-- <phx-scroll class="list-scroll"> -->
      <div class="list-scroll scroll">
        <div
          class="col kanban-col kanban-card-col full-width"
          cdkDropList
          #mecsList="cdkDropList"
          [cdkDropListData]="{ items: filteredMecs }"
          (cdkDropListDropped)="drop($event)"
        >
          <app-kanban-card [items]="filteredMecs" [users]="usersNamesList" [user]="user"></app-kanban-card>
        </div>
    </div>
    <!-- </phx-scroll> -->
  </div>
</div>
